import { render, staticRenderFns } from "./approval_selector.vue?vue&type=template&id=261e4676&"
import script from "./approval_selector.vue?vue&type=script&lang=js&"
export * from "./approval_selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports